import React, { useEffect, useMemo, useRef } from 'react';
import { currentPlaylist } from "./atoms";
import { playingTrack } from "./Sequencer";
import { useRecoilValue } from "recoil";
import Gantt from 'frappe-gantt';

import './Timeline.css';

export const Timeline = () => {
    const ganttRef = useRef(null);
    const containerRef = useRef(null);
    const trackId = useRef(null);
    const playlist = useRecoilValue(currentPlaylist);
    const currentTrack = useRecoilValue(playingTrack);

    const sortedTracks = useMemo(() => {
        return  [...playlist].sort((a, b) =>
            new Date(a.creationDate) - new Date(b.creationDate)
        );
    }, [playlist]);

    useEffect(() => {

        if (trackId.current !== currentTrack?.url) {

            const doneTrack = document.querySelector(".playing-track");

            if (doneTrack) {
                doneTrack.classList.remove("playing-track");
            }

            const index = sortedTracks.findIndex(t => t.url === currentTrack?.url);

            const newTrack = document.querySelector(`.bar-wrapper[data-id='track-${index}']`);

            if (newTrack) {
                newTrack.classList.add('playing-track');
            }

            trackId.current = currentTrack?.url;
        }

    }, [sortedTracks, currentTrack?.url]);

    useEffect(() => {
        const initializeGantt = () => {
            if (!containerRef.current || !playlist || playlist.length === 0) return;

            if (ganttRef.current) {
                containerRef.current.innerHTML = '';
            }

            try {
                const tasks = sortedTracks.map((track, index) => {
                    const startDate = new Date(track.creationDate);

                    let endDate;

                    if (index < sortedTracks.length - 1) {
                        endDate = new Date(sortedTracks[index + 1].creationDate);
                    } else {
                        endDate = new Date(startDate);
                        endDate.setDate(startDate.getDate() + 3);
                    }

                    const safeId = `track-${index}`;

                    return {
                        id: safeId,
                        name: track.title,
                        start: startDate,
                        end: endDate,
                        progress: 100,
                        dependencies: '',
                        custom_class: track.url === trackId.current ? 'playing-track' : '',
                        track: track
                    };
                });

                const firstDate = new Date(sortedTracks[0].creationDate);
                const lastDate = tasks[tasks.length - 1].end;

                let viewMode = 'Week';

                firstDate.setDate(firstDate.getDate() - 3);
                lastDate.setDate(lastDate.getDate() + 3);

                const gantt = new Gantt(containerRef.current, tasks, {
                    readonly: true,
                    view_mode: viewMode,
                    today_button: false,
                    date_format: 'YYYY-MM-DD',
                    step: 24,
                    bar_height: 20,
                    bar_corner_radius: 1,
                    padding: 4,
                    header_height: 10,
                    arrow_curve: 5,
                    start_date: firstDate,
                    end_date: lastDate,
                    infinite_padding: false,
                    popup: ({ task, set_title, set_subtitle, set_details }) => {
                        const trackData = task.track;
                        if (!trackData) return '';

                        const options = { year: 'numeric', month: 'short', day: 'numeric' };
                        const start_date = task.start.toLocaleDateString("en-UK", options);
                        const end_date = task.end.toLocaleDateString("en-UK", options);

                        set_title(`${task.name} ${(trackData.url === trackId.current) ? "(playing)" : ""}`)
                        set_subtitle(`${trackData.authors.join(', ')}`);
                        set_details(`${start_date} - ${end_date} (${task.actual_duration} days)`);

                        return undefined;
                    }
                });

                ganttRef.current = gantt;

            } catch (error) {
                console.error('Error initializing Gantt chart:', error);
            }
        };

        const timer = setTimeout(initializeGantt, 100);

        return () => {
            clearTimeout(timer);
            if (ganttRef.current) {
                ganttRef.current = null;
            }
        };
    }, [playlist, sortedTracks]);

    if (!playlist || playlist.length === 0) {
        return <div>No tracks available</div>;
    }

    return (
        <div
            ref={containerRef}
            style={{
                height: '500px',
                width: '100%',
                overflowX: 'auto',
                padding: '20px 10px'
            }}
        />
    );
};
